import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { ADD_RELEASE_NOTE, SET_RELEASE_NOTES_DATA, UPDATE_RELEASE_NOTE } from "./actionType";

export const getReleaseNotes = (params) => async (dispatch) => {
  try {
    return API.get(`/release-notes/release-notes`, {
      params: {
        page_number: params?.page,
        page_size: params?.limit,
        search: params?.search,
        filter: params?.filter,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_RELEASE_NOTES_DATA,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const addReleaseNote = (payload) => async (dispatch) => {
  try {
    return API.post(`/release-notes/release-notes`, payload).then((res) => {
      if (res && res.status && res.status === 201) {
        dispatch({
          type: ADD_RELEASE_NOTE,
          payload: res?.data?.data,
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const updateReleaseNote = (id, payload) => async (dispatch) => {
  try {
    return API.put(`/release-notes/release-notes/${id}`, payload).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: UPDATE_RELEASE_NOTE,
          payload: res?.data?.data,
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const deleteReleaseNote =
  ({ id, payload }) =>
  async (dispatch) => {
    try {
      return API.delete(`/release-notes/release-notes/${id}`, {
        data: { ...payload },
      }).then((res) => {
        if (res && res?.status && res?.status === 200) {
          return res;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

export const getPublishedReleaseNotes = () => async () => {
  try {
    return API.get(`/release-notes/release-notes/published`).then((res) => {
      if (res && res.status && res.status === 200) {
        return res?.data?.data;
      } else {
        return [];
      }
    });
  } catch (error) {
    console.log(error);
    return [];
  }
};
